module.exports = require("!!vue-loader!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./Announcement.md");


//////////////////
// WEBPACK FOOTER
// ../Announcement.md
// module id = ZoFw
// module chunks = 0